import { Component, Host, h, Prop, Watch, Element, ComponentInterface } from '@stencil/core';
import { HTMLAnchorElementTarget } from '../../components';

@Component({
  tag: 'vds-submenu-stage',
  styleUrl: 'vds-submenu-stage.scss',
  shadow: true,
})
export class VdsSubmenuStage implements ComponentInterface {

  @Element() el!: HTMLVdsSubmenuStageElement;

  @Prop({ mutable: true, reflect: true }) hidden: boolean = true;

  @Prop({ mutable: true, reflect: true }) open: boolean = false;

  @Prop() paddingX: boolean = false;

  @Prop() paddingY: boolean = false;

  @Prop() showHeader: boolean = false;

  @Prop() headerLabel: string;

  @Prop() readMoreHref: string;

  @Prop() readMoreLabel: string;

  @Prop() readMoreTarget: HTMLAnchorElementTarget = '_self';

  private subMenus: HTMLVdsSubmenuElement[] = [];

  private slides: HTMLVdsSlidesElement[] = [];

  private search: boolean = false;

  @Watch('hidden')
  toggleSubmenu(): void {
    this.toggleSubmenusVisibility(this.hidden);
    this.toggleSlidesAutoplay(this.hidden);
  }

  render() {
    const { hidden, paddingX, paddingY, showHeader, search, open } = this;

    return (
      <Host class={{
        'hidden': hidden,
        'block': !hidden
      }}>
        <div class={{
          'flex flex-col w-full': true,
          'relative h-full': !search,
          'h-inherit max-w-[1200px]': search,
          'fixed': open && search
        }}>

          { showHeader && (
            <div class="flex justify-between items-center px-6 py-3">
              <slot name="header"></slot>
            </div>
          )}

          <div class={{
            'flex-1 w-full h-full': true,
            'overflow-y-auto': !search,
            'overflow-y-visible': search,
            'py-6': paddingY,
            'px-6': paddingX
          }}>

            <slot></slot>

          </div>

        </div>
      </Host>
    );
  }

  componentDidRender(): void {
      this.subMenus = Array.from(this.el.querySelectorAll<HTMLVdsSubmenuElement>(':scope > vds-submenu'));
      this.slides = Array.from(this.el.querySelectorAll<HTMLVdsSlidesElement>(':scope vds-slides'));
      if(this.el.slot == 'search') {
        this.search = true;
      }
  }

  private toggleSubmenusVisibility(hidden: boolean): void {
    this.subMenus.forEach(x => x.hidden = hidden);
  }

  private toggleSlidesAutoplay(hidden: boolean): void {
    this.slides.forEach(x => hidden ? x.stopAutoplay() : x.startAutoplay());
  }

}
